import Testimonials from '../sections/Testimonials';
import Stats from '../sections/Stats';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';

const TestimonialsPage = () => (
  <>
    <SEO
      title="Client Testimonials | Farwings Tech Solutions"
      description="Read what our clients have to say about partnering with Farwings Tech Solutions for their custom software and app development needs."
      breadcrumbs={[
        { name: 'Home', path: '/' },
        { name: 'Testimonials', path: '/testimonials' },
      ]}
    />
    <PageHero title="Clients">
      Business owners from India and the UAE on what it was like to plan, build and launch with Farwings.
    </PageHero>
    <Testimonials />
    <Stats />
  </>
);

export default TestimonialsPage;
